export const GOOGLE_MAP_KEY = 'AIzaSyAvjlCVEB4r6Q__eN2AinXwxjbNWPPK1BE';

export const ACCESS_TOKEN_KEY = `access-token-${process.env.NODE_ENV}`;